import { render, staticRenderFns } from "./SocialMediaContainer.vue?vue&type=template&id=221d7674&"
import script from "./SocialMediaContainer.vue?vue&type=script&lang=js&"
export * from "./SocialMediaContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports